import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { useParams } from 'react-router-dom';
import { BrandDetailWidget } from 'widgets/content/ui/BrandDetailWidget';

export const BrandsDetailPage = () => {
  const { app_type, id } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle(`Бренды ${app_type?.toUpperCase()} #${id}`));
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Изменить'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <BrandDetailWidget />;
};
